// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { AiTierBudgetsSchema } from './AiTierBudgetsSchema'
import type { AiTierBudgets } from './AiTierBudgetsSchema'
import { ApplicationGenerationLimitWithRelationsSchema } from './ApplicationGenerationLimitRelationsSchema'
import type { ApplicationGenerationLimitWithRelations } from './ApplicationGenerationLimitRelationsSchema'
import { LicenseSchema } from './LicenseSchema';

/////////////////////////////////////////
// LICENSE RELATION SCHEMA
/////////////////////////////////////////

export type LicenseRelations = {
  aiTierBudgets?: AiTierBudgets | null;
  applicationGenerationLimits: ApplicationGenerationLimitWithRelations[];
};

export type LicenseWithRelations = z.infer<typeof LicenseSchema> & LicenseRelations

export const LicenseWithRelationsSchema: z.ZodType<LicenseWithRelations> = LicenseSchema.merge(z.object({
  aiTierBudgets: z.lazy(() => AiTierBudgetsSchema).nullable(),
  applicationGenerationLimits: z.lazy(() => ApplicationGenerationLimitWithRelationsSchema).array(),
}))